// 巡护打卡相关接口
import request from '../utils/axios'

// 获取区域乡镇名称下拉框(工作人员)  1:查询，2：新增或编辑
export function GetAreaBox(type) {
    return request({
      url: `/Patrol/GetAreaBox?type=${type}`,
      method: 'get',
    })
}

// 根据管理区域获取巡护人 (工作人员)
export function GetPatrolUserByArea(areaId) {
    return request({
        url: `/Patrol/GetPatrolUserByArea?areaId=${areaId}`,
        method: 'get',
    })
}

// 获取巡护人员列表 (工作人员)
export function GetPatrolsUserLis(params) {
    return request({
        url: "/Patrol/GetPatrolsUserLis",
        method: 'post',
        data:params
    })
}

// 添加巡护人员(工作人员)
export function AddPatrolsUser(params) {
    return request({
        url: "/Patrol/AddPatrolsUser",
        method: 'post',
        data:params
    })
}

// 修改巡护人员(工作人员)
export function UpdatePatrolsUser(params) {
    return request({
        url: "/Patrol/UpdatePatrolsUser",
        method: 'post',
        data:params
    })
}

// 删除巡护人员(工作人员)
export function DeletePatrolsUser(id) {
    return request({
      url: `/Patrol/DeletePatrolsUser?id=${id}`,
      method: 'get',
    })
}

// 获取巡护人员详情接口(工作人员)
export function GetPatrolsUserDealLis(id) {
    return request({
      url: `/Patrol/GetPatrolsUserDealLis?id=${id}`,
      method: 'get',
    })
}


// 巡护上报 (工作人员)
export function AddPatrolsEvent(params) {
    return request({
        url: "/Patrol/AddPatrolsEvent",
        method: 'post',
        data:params
    })
}
// 获取巡护执法列表(工作人员)
export function GetPatrolsDealLis(params) {
    return request({
        url: "/Patrol/GetPatrolsDealLis ",
        method: 'post',
        data:params
    })
}

// 获取巡护详情(工作人员)
export function GetPatrolsDealDetails(id) {
    return request({
      url: `/Patrol/GetPatrolsDealDetails?id=${id}`,
      method: 'get',
    })
}

// 处理巡护执法(工作人员)
export function UpdatePatrolsDeal(params) {
    return request({
        url: "/Patrol/UpdatePatrolsDeal ",
        method: 'post',
        data:params
    })
}

// 获取巡护点信息和上报处理详情(工作人员)
export function GetPatroAndUploadDetailsById(id) {
    return request({
      url: `/Patrol/GetPatroAndUploadDetailsById?id=${id}`,
      method: 'get',
    })
}

// 获取巡护上报对应的事件(工作人员)
export function GetPatrolsEventFlowchart(id) {
    return request({
      url: `/Patrol/GetPatrolsEventFlowchart?id=${id}`,
      method: 'get',
    })
}

// 获取总的巡护统计(工作人员)
export function GetPatrolsCount(params) {
    return request({
      url: "/Patrol/GetPatrolsCount",
      method: 'post',
      data:params
  })
}

// 获取总的巡护统计(工作人员)
export function GetPatrolsCountByUserLis(params) {
    return request({
      url: "/Patrol/GetPatrolsCountByUserLis",
      method: 'post',
      data:params
  })
}

// 获取个人巡护详情统计(工作人员)
export function GetPatrolsCountByUserDetails(params) {
    return request({
      url: "/Patrol/GetPatrolsCountByUserDetails",
      method: 'post',
      data:params
  })
}

// 获取巡护统计 单个区域(工作人员)
export function GetPatrolsCountByAreaId(params) {
    return request({
      url: "/Patrol/GetPatrolsCountByAreaId",
      method: 'post',
      data:params
  })
}

// 获取巡护管理区域(工作人员)
export function GetPatrolsUserLevel() {
    return request({
      url: `/Patrol/GetPatrolsUserLevel`,
      method: 'get',
    })
}

// 获取导出巡护记录下拉框(工作人员)
export function GetDownPatrolExcelBox() {
    return request({
      url: `/Patrol/GetDownPatrolExcelBox`,
      method: 'get',
    })
}

// 导出巡护记录(工作人员)
export function DownPatrolExcel(params) {
    return request({
      url: `/Patrol/DownPatrolExcel`,
      method: 'post',
      data:params,
      responseType:'blob'
    })
}

// 获取本月总得巡护次数
export function GetThisMonthPatrolsCount() {
    return request({
      url: `/Patrol/GetThisMonthPatrolsCount`,
      method: 'get',
    })
}